import { defineComponent as P, ref as d, watch as b, createElementBlock as n, openBlock as r, createCommentVNode as l, createElementVNode as a, createVNode as u, unref as _, toDisplayString as g } from "vue";
import { ScalarIconCaretLeft as f, ScalarIconCaretRight as N } from "@scalar/icons";
import { findPreviousPage as k, findNextPage as y } from "../helpers/pageNavigation.js";
const C = { class: "t-editor__page-nav" }, x = {
  key: 0,
  class: "t-editor__page-nav__container"
}, T = { class: "t-editor__page-nav__item-label" }, S = { class: "t-editor__page-nav__item-label" }, I = /* @__PURE__ */ P({
  __name: "PageNav",
  props: {
    activePage: {},
    sidebar: {}
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(m, { emit: p }) {
    const t = m, v = p, i = d(null), o = d(null);
    return b(
      [() => t.activePage, () => t.sidebar, () => t.sidebar?.items],
      () => {
        i.value = k(t.sidebar, t.activePage), o.value = y(t.sidebar, t.activePage);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (s, e) => (r(), n("div", C, [
      s.sidebar && (i.value || o.value) ? (r(), n("div", x, [
        i.value ? (r(), n("button", {
          key: 0,
          class: "t-editor__page-nav__item t-editor__page-nav__item-left",
          type: "button",
          onClick: e[0] || (e[0] = (c) => v("goToPrevPage", i.value))
        }, [
          a("div", T, [
            u(_(f)),
            e[2] || (e[2] = a("span", null, "Previous", -1))
          ]),
          a("b", null, g(s.sidebar.items[i.value]?.title), 1)
        ])) : l("", !0),
        o.value ? (r(), n("button", {
          key: 1,
          class: "t-editor__page-nav__item t-editor__page-nav__item-right",
          type: "button",
          onClick: e[1] || (e[1] = (c) => v("goToNextPage", o.value))
        }, [
          a("div", S, [
            e[3] || (e[3] = a("span", null, "Next", -1)),
            u(_(N))
          ]),
          a("b", null, g(s.sidebar.items[o.value]?.title), 1)
        ])) : l("", !0)
      ])) : l("", !0)
    ]));
  }
});
export {
  I as default
};
